// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    makeHandlerChainAwaitable,
    markSkipOnCompleteIfOnSuccessIsSet,
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import {
    createShipTo as createShipToApi,
    updateShipTo as updateShipToApi,
} from "@insite/client-framework/Services/CustomersService";
import {
    AddOrUpdateShipTo,
    chain,
} from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/UpdateShipTo";

import loadShipTo from "@insite/client-framework/Store/Data/ShipTos/Handlers/LoadShipTo";
import { getShipToState } from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors";

export const XngAddOrUpdateShipTo: typeof AddOrUpdateShipTo = async props => {
    try {
        if (props.parameter.shipTo.isNew) {
            props.apiResult = await createShipToApi({
                shipTo: props.parameter.shipTo,
            });
        } else if (props.parameter.isEdit) {
            props.apiResult = await updateShipToApi({
                billToId: props.parameter.billToId,
                shipTo: props.parameter.shipTo,
            });
        } else {
            props.apiResult = props.parameter.shipTo;
        }
    } catch (error) {
        // XNG-Change
        markSkipOnCompleteIfOnSuccessIsSet(props);
        props.apiResult = { errorMessage: error?.errorJson?.message } as any;
        const shipToState = getShipToState(props.getState(), props.apiResult.id);
        props.dispatch({
            type: "Pages/CheckoutShipping/CompleteUpdateShipTo",
            shipTo: shipToState.value!,
        });
        props.parameter?.onSuccess?.(props.apiResult as any);

        return false;
    }

    // reload to make sure we get validation
    await makeHandlerChainAwaitable(loadShipTo)({
        billToId: props.parameter.billToId,
        shipToId: props.apiResult.id,
    })(props.dispatch, props.getState);
};

replaceInChain(chain, AddOrUpdateShipTo, XngAddOrUpdateShipTo);
